import { Reducer } from "redux";

import { TermsResponse } from "./terms";
import { TermsAction, TermsGetSuccessActionType } from "./terms.actions";

export const termsReducer: Reducer<TermsState, TermsAction> = (
  state = {},
  action
) => {
  switch (action.type) {
    case TermsGetSuccessActionType:
      return {
        terms: action.terms,
      };
    default:
      return state;
  }
};

export interface TermsState {
  terms?: TermsResponse | null;
}
